import { render, staticRenderFns } from "./_IbxPassageItemsCard.vue?vue&type=template&id=ac29ea98"
import script from "./_IbxPassageItemsCard.vue?vue&type=script&lang=js"
export * from "./_IbxPassageItemsCard.vue?vue&type=script&lang=js"
import style0 from "./_IbxPassageItemsCard.vue?vue&type=style&index=0&id=ac29ea98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports